import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const ImportKeywords = () => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(""); // blank = General category

  const ToasterToggle = JSON.parse(localStorage.getItem("Toaster"));

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_BASE_URL}keyword-category/all`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setCategories(res.data);
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError("");
  };

  const handleFileUpload = async () => {
    try {
      if (!file) {
        setError("Please select a file.");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("categoryId", selectedCategory || ""); // backend will use General

      const URL = process.env.REACT_APP_BASE_URL;
      const res = await api.post(`${URL}keyword/upload`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (ToasterToggle) {
        toast.success(res.data.message || "Success!");
      }

      setFile(null);
      setSelectedCategory("");
      document.getElementById("fileInput").value = null;
    } catch (error) {
      console.error("Error uploading file:", error);
      if (ToasterToggle) {
        toast.error("Error uploading file. Please try again.");
      }
      setError("Error uploading file. Please try again.");
    }
  };

  return (
    <div
      style={{
        marginBottom: "20px",
        padding: "10px",
        border: "1px solid #10104e",
        borderRadius: "5px",
      }}
    >
      {/* CATEGORY DROPDOWN */}
      <FormControl
        fullWidth
        sx={{
          mb: 2,
          "& .MuiInputLabel-root": { color: "white" }, // label
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "white" }, // border
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "white" },
          "& .MuiSelect-icon": { color: "white" }, // dropdown arrow
        }}
      >
        <InputLabel sx={{ color: "white" }}>
          Select Category (optional)
        </InputLabel>

        <Select
          value={selectedCategory}
          label="Select Category"
          onChange={(e) => setSelectedCategory(e.target.value)}
          sx={{
            color: "white", // selected text
            "& .MuiSelect-select": { color: "white" },
            "& .MuiOutlinedInput-input": { color: "white" },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                bgcolor: "#1a1a1a", // dropdown background
                color: "white", // dropdown text
                "& .MuiMenuItem-root": {
                  color: "white",
                  "&.Mui-selected": {
                    backgroundColor: "#333 !important",
                  },
                  "&:hover": {
                    backgroundColor: "#222",
                  },
                },
              },
            },
          }}
        >
          <MenuItem value="" sx={{ color: "white" }}>
            General (Default)
          </MenuItem>

          {categories.map((cat) => (
            <MenuItem key={cat._id} value={cat._id} sx={{ color: "white" }}>
              {cat.categoryName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* FILE INPUT */}
      <label style={{ marginRight: "10px" }}>Choose File:</label>
      <input type="file" id="fileInput" onChange={handleFileChange} />

      <Button
        variant="contained"
        style={{ backgroundColor: "black", marginLeft: "10px" }}
        onClick={handleFileUpload}
      >
        Upload File
      </Button>

      {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}
    </div>
  );
};

export default ImportKeywords;
